import theme from "@monorepo/styles/theme";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";

export const StyledInput = styled(InputBase)(() => ({
  "& .MuiInputBase-input": {
    borderBottom: `1px solid'${theme.palette.geyserGray.main}`,
    fontSize: theme.typography.body2.fontSize,
    paddingLeft: "3px",
    "&:focus": {
      borderColor: theme.palette.primary.main,
    },
  },
}));
